/**
 * Ocean FCL (export / import) report catalog.
 * Register via reportModules.js — use moduleId "ocean-fcl".
 *
 * Export: FCLExportReports APIs only.
 * Import: FCLImportReports APIs only.
 */
import { FCL_IMPORT_REPORT_REGISTRY } from "../ocean/import/importReportRegistry";

const entry = (def) => def;

const importCatalogEntries = Object.entries(FCL_IMPORT_REPORT_REGISTRY).map(([slug, cfg]) =>
    entry({
        id: `import-${slug}`,
        label: cfg.title,
        description: cfg.description,
        group: cfg.group,
        modes: ["import"],
        badge: "LIVE",
        linkType: "route",
        path: `/ocean/import/reports/${slug}`,
    })
);

/** @type {Array<object>} */
export const OCEAN_FCL_CATALOG = [
    // ── Export (active — FCLExportReports API) ─────────────────────────────────
    entry({
        id: "export-booking",
        label: "Booking Report",
        description: "Bookings, profitability, and carrier mix.",
        group: "ops",
        modes: ["export"],
        badge: "LIVE",
        linkType: "route",
        path: "/ocean/export/reports/booking",
    }),
    entry({
        id: "export-sales-booking",
        label: "Booking Salesperson Report",
        description: "Bookings and revenue by salesperson.",
        group: "sales",
        modes: ["export"],
        badge: "LIVE",
        linkType: "route",
        path: "/ocean/export/reports/booking-salesperson",
    }),

    // ── Export (disabled) ──────────────────────────────────────────────────────
    // entry({ id: "rate-quote", ... modes: ["export", "import"], path: "/quotation-report" }),
    // entry({ id: "booking", ... path: "/booking-report" }),
    // entry({ id: "accounting", ... path: "/accounting-report" }),
    // entry({ id: "status-audit", ... path: "/status-audit" }),
    // legacy export reports (trucking, container, profit, manifest) …

    // ── Import (active — FCLImportReports API) ─────────────────────────────────
    ...importCatalogEntries,

    // ── Import (disabled) ──────────────────────────────────────────────────────
    // entry({ id: "rate-quote", label: "Rate Quote Report", modes: ["import"], path: "/quotation-report" }),
    // entry({ id: "booking", label: "Booking Report", modes: ["import"], path: "/booking-report" }),
    // entry({ id: "accounting", ... path: "/accounting-report" }),
    // entry({ id: "import-file-cancel", linkType: "legacy", legacyPage: "rptFileCancellation.aspx" }),
    // entry({ id: "import-eta-prealert", ... }),
    // entry({ id: "import-sales-booking", ... }),
    // entry({ id: "import-customs", ... }),
];
